/**
 * 📜 Termos de Uso — Workflow Manager
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const TermosPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-6"
        >
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>

        <h1 className="text-2xl font-bold mb-1">Termos de Uso</h1>
        <p className="text-sm text-gray-500 mb-8">Última atualização: 11 de março de 2026</p>

        <div className="prose prose-sm max-w-none text-gray-700 space-y-4">
          <h2 className="text-lg font-semibold mt-6">1. Aceitação dos Termos</h2>
          <p>
            Ao acessar ou usar o Workflow Manager ("Plataforma"), você concorda em cumprir
            e estar vinculado a estes Termos de Uso. Se não concordar com qualquer parte
            destes termos, não utilize a Plataforma.
          </p>

          <h2 className="text-lg font-semibold mt-6">2. Descrição do Serviço</h2>
          <p>
            O Workflow Manager é uma plataforma de gestão de processos Lean que oferece mapeamento
            de fluxo de valor (VSM), execução de workflows, planos de ação 5W2H, monitoramento de
            ganhos Kaizen, governança de processos e gamificação de equipes.
          </p>

          <h2 className="text-lg font-semibold mt-6">3. Conta e Registro</h2>
          <p>
            Você é responsável por manter a confidencialidade de suas credenciais de acesso.
            Cada conta é pessoal e intransferível. Notifique-nos imediatamente sobre qualquer
            uso não autorizado.
          </p>

          <h2 className="text-lg font-semibold mt-6">4. Planos e Pagamento</h2>
          <p>
            Os planos pagos são cobrados conforme o ciclo escolhido (mensal ou anual). Upgrades
            são proporcionais. Cancelamentos tomam efeito no próximo ciclo. O plano Free pode
            ter funcionalidades limitadas.
          </p>

          <h2 className="text-lg font-semibold mt-6">5. Dados e Propriedade</h2>
          <p>
            Você retém todos os direitos sobre os dados inseridos na Plataforma. Concede-nos
            uma licença limitada para processar seus dados exclusivamente para prestação do
            serviço. Seus dados nunca são vendidos ou compartilhados com terceiros para
            fins publicitários.
          </p>

          <h2 className="text-lg font-semibold mt-6">6. Uso Aceitável</h2>
          <p>
            É proibido: (a) usar a Plataforma para fins ilegais; (b) tentar acessar dados de
            outras organizações; (c) fazer engenharia reversa; (d) sobrecarregar intencionalmente
            o serviço; (e) revender acesso sem autorização.
          </p>

          <h2 className="text-lg font-semibold mt-6">7. Disponibilidade</h2>
          <p>
            Embora nos esforcemos para manter alta disponibilidade, não garantimos serviço
            ininterrupto. Manutenções programadas serão comunicadas com antecedência.
          </p>

          <h2 className="text-lg font-semibold mt-6">8. Limitação de Responsabilidade</h2>
          <p>
            Na máxima extensão permitida pela lei, nossa responsabilidade total é limitada
            ao valor pago pelo serviço nos últimos 12 meses. Não nos responsabilizamos por
            danos indiretos, lucros cessantes ou perda de dados causada por atos fora de
            nosso controle.
          </p>

          <h2 className="text-lg font-semibold mt-6">9. Rescisão</h2>
          <p>
            Podemos suspender ou encerrar sua conta em caso de violação destes termos.
            Você pode cancelar sua conta a qualquer momento. Após cancelamento, seus
            dados serão mantidos por 30 dias, prazo em que podem ser exportados.
          </p>

          <h2 className="text-lg font-semibold mt-6">10. Legislação Aplicável</h2>
          <p>
            Estes termos são regidos pelas leis da República Federativa do Brasil.
            Foro da comarca de São Paulo/SP para dirimir eventuais litígios.
          </p>

          <h2 className="text-lg font-semibold mt-6">11. Contato</h2>
          <p>
            Para dúvidas sobre estes termos: <strong>contato@workflowbrasil.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermosPage;
